module.exports = __webpack_public_path__ + "img/59.d8bce531.jpg";